import { io } from 'socket.io-client';

const SOCKET_URL = import.meta.env.VITE_API_URL;

class SocketService {
  constructor() {
    this.socket = null;
    this.progressCallbacks = new Map();
    this.isConnected = false;
  }

  connect() {
    if (this.socket && this.socket.connected) {
      return Promise.resolve();
    }

    return new Promise((resolve, reject) => {
      this.socket = io(`${SOCKET_URL}/progress`, {
        transports: ['websocket', 'polling'],
        autoConnect: true,
      });

      this.socket.on('connect', () => {
        console.log('Socket.IO connected to progress namespace');
        this.isConnected = true;
        resolve();
      });

      this.socket.on('disconnect', () => {
        console.log('Socket.IO disconnected');
        this.isConnected = false;
      });

      this.socket.on('connect_error', (error) => {
        console.error('Socket.IO connection error:', error);
        this.isConnected = false;
        reject(error);
      });

      this.socket.on('progress_update', (data) => {
        console.log('Progress update received:', data);
        this.handleProgressUpdate(data);
      });

      // Set connection timeout
      setTimeout(() => {
        if (!this.isConnected) {
          reject(new Error('Socket connection timeout'));
        }
      }, 5000);
    });
  }

  disconnect() {
    if (this.socket) {
      this.socket.disconnect();
      this.socket = null;
      this.isConnected = false;
      this.progressCallbacks.clear();
    }
  }

  // Subscribe to progress updates for a specific job
  subscribeToJob(jobId, callback) {
    if (!this.socket || !this.isConnected) {
      console.warn('Socket not connected, cannot subscribe to job');
      return;
    }

    this.progressCallbacks.set(jobId, callback);
    this.socket.emit('join_job', jobId);
    console.log(`Subscribed to job ${jobId}`);
  }

  // Unsubscribe from progress updates for a specific job
  unsubscribeFromJob(jobId) {
    this.progressCallbacks.delete(jobId);
    console.log(`Unsubscribed from job ${jobId}`);
  }

  // Handle incoming progress updates
  handleProgressUpdate(data) {
    const { job_id } = data;
    if (job_id && this.progressCallbacks.has(job_id)) {
      const callback = this.progressCallbacks.get(job_id);
      callback(data);
    }
  }

  // Get connection status
  isSocketConnected() {
    return this.isConnected && this.socket && this.socket.connected;
  }

  // Retry connection
  async reconnect() {
    this.disconnect();
    return this.connect();
  }
}

// Create singleton instance
const socketService = new SocketService();

export default socketService; 